module.exports = __webpack_public_path__ + "static/xero-logo-21155709b6c125868b76c2cd08002d75.svg";